var _circle, _circle2, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBalance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 44,
    stroke: "#10A5F5",
    strokeWidth: 6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 34,
    r: 12,
    stroke: "#10A5F5",
    strokeWidth: 4,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 28v7l5 3",
    stroke: "#10A5F5",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-20 58 56)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 46,
    width: 40,
    height: 22,
    rx: 3,
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 49c2 2 4 3 6 3M72 62c-2-2-4-3-6-3",
    stroke: "#EDEDED",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 56,
    y: 61,
    textAnchor: "middle",
    fontSize: 14,
    fontWeight: "bold",
    fill: "#FFFFFF"
  }, "\u20AC"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalance);
export default __webpack_public_path__ + "static/media/balance.276494955d419960eb19c10a050793e5.svg";
export { ForwardRef as ReactComponent };